'use client';

import { c as _c } from "react/compiler-runtime";
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink';
import { Stamp } from '@src/components/TopNavV4/Stamp';
import { useTopNav } from '@src/components/TopNavV4/TopNavContext';
import { TopNavMobileFooter } from '@src/components/TopNavV4/TopNavMobile/TopNavMobileFooter';
import type { TopNavItem } from '@src/components/TopNavV4/TopNavProps';
import { useTrackSelectNavCta } from '@src/utils/analytics.util';
import { cn } from '@src/utils/tailwind';
export const TopNavMobileMenu = () => {
  const $ = _c(11);
  const trackSelectNavCta = useTrackSelectNavCta();
  const {
    items,
    setExpanded,
    setExpandedMenu,
    setMobileSubExpanded
  } = useTopNav();
  const renderTitle = _temp;
  let t0;
  if ($[0] !== items || $[1] !== setExpanded || $[2] !== setExpandedMenu || $[3] !== setMobileSubExpanded || $[4] !== trackSelectNavCta) {
    t0 = items?.map((item, index) => {
      if (!item?.hasSubItems && !item?.hasMiniMenu) {
        return <LocalizedLink onClick={() => {
          trackSelectNavCta({
            "cta url": item.href
          });
          setExpanded(false);
        }} data-testid={`nav-menu-${index}`} key={item?.title} className="py-3 text-heading-4 font-lateral font-medium text-left" href={item.href ?? ""} rel={item.newTab ? "noopener noreferrer" : ""} target={item.newTab ? "_blank" : "_self"}>{renderTitle(item)}</LocalizedLink>;
      }
      return <button data-testid={`nav-menu-${index}`} key={item.title} className={cn("py-3 text-heading-4 font-lateral font-medium text-left", "relative flex w-full cursor-pointer items-center gap-2 transition-all")} onClick={() => {
        setExpandedMenu(item);
        setMobileSubExpanded(true);
      }}>{renderTitle(item)}<ChevronRightIcon className="size-5 text-bodi-accent-bright-500" /></button>;
    });
    $[0] = items;
    $[1] = setExpanded;
    $[2] = setExpandedMenu;
    $[3] = setMobileSubExpanded;
    $[4] = trackSelectNavCta;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  let t1;
  if ($[6] !== t0) {
    t1 = <div className="flex flex-col gap-2 px-4 py-6 pt-4">{t0}</div>;
    $[6] = t0;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <TopNavMobileFooter />;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t1) {
    t3 = <>{t1}{t2}</>;
    $[9] = t1;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};
function _temp(menu) {
  return <div className="flex w-fit items-center gap-2">{menu.title}<Stamp text={menu.stamp} /></div>;
}